// src/components/StoryCustomizer.js
import React, { useState } from 'react';

function StoryCustomizer({ onStart, loading }) {
  const [showCustom, setShowCustom] = useState(false);
  const [formData, setFormData] = useState({
    genre: 'fantasía',
    titulo: '',
    userPrompt: '',
    userRules: '',
    narrativePerson: 'second',
    storyTone: 'epic',
    storyLength: 'medium'
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onStart(formData);
  };

  return (
    <div className="customizer-container">
      <form onSubmit={handleSubmit}>
        {/* Género (siempre visible) */}
        <div className="form-group">
          <label>🌌 Género de tu universo</label>
          <select 
            name="genre"
            value={formData.genre} 
            onChange={handleChange}
            className="form-control"
          >
            <option value="fantasía">Fantasía Épica</option>
            <option value="ciencia ficción">Ciencia Ficción</option>
            <option value="terror">Terror</option>
            <option value="misterio">Misterio</option>
            <option value="aventura">Aventura</option>
          </select>
        </div>

        {/* Título (opcional) */}
        <div className="form-group">
          <label>📝 Título (opcional)</label>
          <input
            type="text"
            name="titulo"
            value={formData.titulo}
            onChange={handleChange}
            placeholder="Ej: La búsqueda del dragón perdido"
            className="form-control"
          />
        </div>

        {/* Botón para mostrar/ocultar personalización avanzada */}
        <button 
          type="button"
          className="btn-toggle"
          onClick={() => setShowCustom(!showCustom)}
        >
          {showCustom ? '▼ Ocultar personalización' : '▶ Mostrar personalización avanzada'}
        </button>

        {showCustom && (
          <div className="custom-options">
            <h3>🎨 Personaliza tu universo</h3>
            
            {/* Prompt personalizado */}
            <div className="form-group">
              <label>📖 Describe la historia que quieres vivir</label>
              <textarea
                name="userPrompt"
                value={formData.userPrompt}
                onChange={handleChange}
                placeholder="Ej: Un mago anciano busca a un aprendiz para recuperar un artefacto perdido en las montañas..."
                rows="4"
                className="form-control"
              />
            </div>

            {/* Reglas del universo */}
            <div className="form-group">
              <label>⚔️ Reglas inquebrantables de tu universo</label>
              <textarea
                name="userRules"
                value={formData.userRules}
                onChange={handleChange}
                placeholder="Ej: La magia no puede revivir a los muertos, los dragones son inteligentes y pacíficos..."
                rows="3"
                className="form-control"
              />
            </div>

            {/* Punto de vista */}
            <div className="form-group">
              <label>👤 Punto de vista narrativo</label>
              <select 
                name="narrativePerson"
                value={formData.narrativePerson} 
                onChange={handleChange}
                className="form-control"
              >
                <option value="first">Primera persona ("Yo...")</option>
                <option value="second">Segunda persona ("Tú...")</option>
                <option value="third">Tercera persona ("Él/Ella...")</option>
              </select>
            </div>

            {/* Tono */}
            <div className="form-group">
              <label>🎭 Tono de la historia</label>
              <select 
                name="storyTone"
                value={formData.storyTone} 
                onChange={handleChange}
                className="form-control"
              >
                <option value="epic">Épico (heroico y grandioso)</option>
                <option value="dark">Oscuro (suspenso y peligro)</option>
                <option value="humorous">Humorístico (ligero y divertido)</option>
                <option value="mysterious">Misterioso (intriga y secretos)</option>
              </select>
            </div>

            {/* Longitud */}
            <div className="form-group">
              <label>📏 Longitud deseada</label>
              <select 
                name="storyLength"
                value={formData.storyLength} 
                onChange={handleChange}
                className="form-control"
              >
                <option value="short">Corta (5-10 interacciones)</option>
                <option value="medium">Media (10-20 interacciones)</option>
                <option value="long">Larga (20-50 interacciones)</option>
              </select>
            </div>
          </div>
        )}

        {/* Botón de crear */}
        <button 
          type="submit" 
          className="btn btn-primary btn-large"
          disabled={loading}
        >
          {loading ? '✨ Creando universo...' : '🌟 CREAR UNIVERSO'}
        </button>
      </form>
    </div>
  );
}

export default StoryCustomizer;